import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ICostCategory, IServiceType } from './interfaces';

export const getCostCategoryList = (data: IDynamicTableParams) => {
  return instance()
    .post<ICostCategory[]>(`/costCategory/list`, data)
    .then((response) => response.data);
};

export const getCostCategoryAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>(`/costCategory/availableColumns`)
    .then((response) => response.data);
};

export const getCostCategoryAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>(`/costCategory/availableGroupColumns`)
    .then((response) => response.data);
};

export const loadCostCategory = (costCategoryId: number) => {
  return instance()
    .get<ICostCategory>(`/costCategory/${costCategoryId}/load`)
    .then((response) => response.data);
};

export const createCostCategory = (costCategory: ICostCategory) => {
  return instance()
    .post<ICostCategory>('/costCategory/save', costCategory)
    .then((response) => response.data);
};

export const updateCostCategory = (costCategory: ICostCategory) => {
  return instance()
    .post<ICostCategory>(`/costCategory/${costCategory.costCategoryId}/update`, costCategory)
    .then((response) => response.data);
};

export const archiveCostCategory = (id: number) => {
  return instance()
    .post('/costCategory/archive', { id })
    .then((response) => response.data);
};

export const recoverCostCategory = (id: number) => {
  return instance()
    .post('/costCategory/recover', { id })
    .then((response) => response.data);
};

export const getServiceTypeListAllNotDeleted = () => {
  return instance()
    .get<IServiceType[]>(`/serviceType/listAllNotDeleted`)
    .then((response) => response.data);
};
